// src/modules/butterfly-world/ButterflyBootScreen.tsx
import { Butterfly } from './butterfly-icon';

import './butterfly-loader.css';

/** Полноэкранная заставка луга: один и тот же вид на всех этапах загрузки, чтобы экран не мигал. */
export function ButterflyBootScreen({ text = 'Открываем луг…', hidden = false }: { text?: string; hidden?: boolean }) {
  return <div className={`butterfly-boot${hidden ? ' butterfly-boot--hidden' : ''}`} role="status" aria-live="polite" aria-hidden={hidden || undefined}>
    <span className="butterfly-boot__hill butterfly-boot__hill--back" />
    <span className="butterfly-boot__hill" />
    <div className="butterfly-boot__card">
      <span className="butterfly-boot__mark"><span className="butterfly-boot__ring" /><span className="butterfly-boot__wings"><Butterfly size={56} /></span></span>
      <h1>Ожившие бабочки</h1>
      <p>{text}</p>
      <span className="butterfly-boot__bar" aria-hidden="true"><i /></span>
    </div>
  </div>;
}
